// Sidebar.tsx — القائمة الجانبيّة بأسلوب shadcn-admin (خلفيّة --sidebar، عنصر نشِط بخلفيّة
// شفّافة + شريط تمييز جانبيّ)، مبنيّة من الصلاحيّات عبر useSidebarMenu (لا نسخ حرفيّ للقالب).
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSidebarMenu } from './useSidebarMenu';
import { getMenuIcon } from './menuIcons';
import { SimpleTooltip } from '../components/ui/simple-tooltip';
import { cn } from '../lib/utils';
import { APP_VERSION_LABEL } from '../version';

interface SidebarProps {
	expanded: boolean;
}

export function Sidebar({ expanded }: SidebarProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const { menuItems, loading } = useSidebarMenu();

	return (
		<div className="flex h-full flex-col bg-sidebar text-sidebar-foreground">
			<div className={cn('flex h-14 items-center gap-2 px-3', !expanded && 'justify-center px-0')}>
				<div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-sidebar-primary font-black text-sidebar-primary-foreground">SS</div>
				{expanded && <span className="truncate font-bold">Smart Stable</span>}
			</div>

			<div className="h-px bg-sidebar-border" />

			<nav className="no-scrollbar flex-1 space-y-0.5 overflow-y-auto p-1.5">
				{menuItems.map((item) => {
					const Icon = getMenuIcon(item);
					const path = item.path || item.route || '/';
					const active = location.pathname.toLowerCase() === path.toLowerCase();
					const label = t(item.text_key || item.permission_key || '', item.text_key || '');
					const key = item.menu_id ?? item.permission_key ?? item.text_key;

					const button = (
						<button
							key={key}
							onClick={() => navigate(path)}
							className={cn(
								'flex w-full items-center gap-2 rounded-lg border-s-2 border-transparent text-start text-[13.5px] transition-colors',
								expanded ? 'py-1 pe-2.5 ps-1' : 'justify-center py-1',
								active ? 'border-s-sidebar-primary bg-sidebar-accent font-bold text-sidebar-foreground' : 'text-sidebar-foreground/80 hover:bg-sidebar-accent/60',
							)}
						>
							<span className="flex size-11 shrink-0 items-center justify-center rounded-lg">
								<Icon size={22} strokeWidth={1.75} />
							</span>
							{expanded && <span className="truncate">{label}</span>}
						</button>
					);

					return expanded ? button : <SimpleTooltip key={key} label={label}>{button}</SimpleTooltip>;
				})}
				{!loading && menuItems.length === 0 && expanded && <p className="px-2.5 py-2 text-xs opacity-70">{t('sidebar.no_items', 'لا توجد عناصر متاحة لهذا الدور.')}</p>}
			</nav>

			<div className="h-px bg-sidebar-border" />
			<p className={cn('py-1.5 text-center font-bold opacity-85', expanded ? 'text-xs' : 'text-[9px]')}>{APP_VERSION_LABEL}</p>
		</div>
	);
}
